import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AllPartners,
  cashProducts,
  Option,
  PartnerFields,
  SelectedPartner,
  TermDetails,
  TOnoManageData,
  TSignerInfoFields,
} from "../types/loans/partners/partners";

type TInitialState = {
  statusOpen: boolean;
  statusSelect: string[];
  statusFilter: string[];
  openAddPartner: boolean;
  allPartners: AllPartners[];
  selectedPrtner: number;
  selectedPartnerData: SelectedPartner | null;
  partnerFields: PartnerFields;
  signerInfoFields: TSignerInfoFields[];
  cashProduct: cashProducts[];
  openPartnerDetailsPanel: boolean;
  partnerAddEditVal: string;
  partnerDetailsEditStatus: boolean;
  partnerTypes: string[];
  onoManagersData: TOnoManageData[];
  productSelect: Option[];
  refreshAllPartnersEntity: boolean;
  searchText: string;
  filteredPartners: any[];
  termFieldRows: TermDetails[];
  states: string[];
};

const initialState: TInitialState = {
  statusOpen: false,
  statusSelect: [],
  statusFilter: [],
  openAddPartner: false,
  allPartners: [],
  selectedPrtner: 0,
  selectedPartnerData: null,
  partnerFields: {
    partnerName: "",
    sCode: "",
    partnerType: "",
    CINnumber: "",
    PANnumber: "",
    address: "",
    POCname: "",
    POCemail: "",
    POCnumber: "",
    rm: "",
    inrerestRate: 0,
    startDate: "",
    termSheetImg: [],
    ndaImage: [],
    logoImage: [],
    incorpoImage: [],
    panImage: [],
    approvedLimit: 0,
    rmId: 0,
    status: "",
    paymentTerms: 0,
    disburse: "",
    signPartnerName: "",
    signAuthPersonName: "",
    signMobile: "",
    signEmail: "",
    signStreet: "",
    signLocality: "",
    signCity: "",
    signState: "",
    signPincode: "",
    signCinNumber: "",
    initiateAgmt: false,
    dist: "",
    state: "",
    pincode: "",
    locality: "",
    country: "",
    otherImage: [],
    kycRequired: false,
    emiType: "",
    initiateKyc: false,
  },
  cashProduct: [],
  openPartnerDetailsPanel: false,
  partnerAddEditVal: "details",
  partnerDetailsEditStatus: false,
  partnerTypes: [],
  onoManagersData: [],
  productSelect: [],
  refreshAllPartnersEntity: false,
  searchText: "",
  filteredPartners: [],
  termFieldRows: [
    {
      rowId: crypto.randomUUID(),
      interestRate: "",
      startDate: "",
      paymentTerms: "",
      products: [],
      status: 1,
    },
  ],
  signerInfoFields: [],
  states: [],
};

export const partner = createSlice({
  name: "partner",
  initialState: initialState,
  reducers: {
    resetArrivalDetails: (state) => {
      return {
        ...initialState,
      };
    },
    setStatusOpen: (state, action: PayloadAction<boolean>) => {
      state.statusOpen = action.payload;
    },
    setStatusSelect: (state, action: PayloadAction<string[]>) => {
      state.statusSelect = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string[]>) => {
      state.statusFilter = action.payload;
    },
    setOpenAddPartner: (state, action: PayloadAction<boolean>) => {
      state.openAddPartner = action.payload;
    },
    setAllPartners: (state, action: PayloadAction<AllPartners[]>) => {
      state.allPartners = action.payload;
    },
    setSelectedPrtner: (state, action: PayloadAction<number>) => {
      state.selectedPrtner = action.payload;
    },
    setSelectedPartnerData: (
      state,
      action: PayloadAction<SelectedPartner | null>,
    ) => {
      state.selectedPartnerData = action.payload;
    },
    setPartnerFields: (state, action: PayloadAction<PartnerFields>) => {
      state.partnerFields = action.payload;
    },
    resetPartnerFields: (state) => {
      state.partnerFields = initialState.partnerFields;
    },
    setCashProduct: (state, action: PayloadAction<cashProducts[]>) => {
      state.cashProduct = action.payload;
    },
    setOpenPartnerDetailsPanel: (state, action: PayloadAction<boolean>) => {
      state.openPartnerDetailsPanel = action.payload;
    },
    setPartnerAddEditVal: (state, action: PayloadAction<string>) => {
      state.partnerAddEditVal = action.payload;
    },
    setEditPartnerDetailsStatus: (state, action: PayloadAction<boolean>) => {
      state.partnerDetailsEditStatus = action.payload;
    },
    setPartnerTypes: (state, action: PayloadAction<string[]>) => {
      state.partnerTypes = action.payload;
    },
    setOnoManagersData: (state, action: PayloadAction<TOnoManageData[]>) => {
      state.onoManagersData = action.payload;
    },

    setProductSelect: (state, action: PayloadAction<Option[]>) => {
      state.productSelect = action.payload;
    },
    removeProductSelect: (state) => {
      state.productSelect = initialState.productSelect;
    },
    setRefreshAllPartnersEntity: (state) => {
      state.refreshAllPartnersEntity = !state.refreshAllPartnersEntity;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setFilteredPartners: (state, action: PayloadAction<any[]>) => {
      state.filteredPartners = action.payload;
    },
    setTermFieldRows: (state, action: PayloadAction<TermDetails[]>) => {
      state.termFieldRows = action.payload;
    },
    resetTermDetails: (state) => {
      state.termFieldRows = initialState.termFieldRows;
    },
    setSignerInfoFields: (
      state,
      action: PayloadAction<TSignerInfoFields[]>,
    ) => {
      state.signerInfoFields = action.payload;
    },
    resetSignerInfoFields: (state) => {
      state.signerInfoFields = [
        {
          id: 0,
          status: 1,
          name: "",
          designation: "",
          signature: [],
          companySeal: [],
        },
      ];
    },
    setState: (state, action: PayloadAction<string[]>) => {
      state.states = action.payload;
    },
  },
});
export const {
  setStatusOpen,
  setStatusSelect,
  setStatusFilter,
  setOpenAddPartner,
  setAllPartners,
  setSelectedPrtner,
  setSelectedPartnerData,
  setPartnerFields,
  setCashProduct,
  setOpenPartnerDetailsPanel,
  setPartnerAddEditVal,
  setEditPartnerDetailsStatus,
  setPartnerTypes,
  setOnoManagersData,
  resetPartnerFields,
  setProductSelect,
  removeProductSelect,
  setSearchText,
  setRefreshAllPartnersEntity,
  setFilteredPartners,
  setTermFieldRows,
  resetTermDetails,
  setSignerInfoFields,
  resetSignerInfoFields,
  setState,
} = partner.actions;
export default partner.reducer;
